import foodImg from '../images/food.png';
import handImg from '../images/hand.png';
import heartImg from '../images/heart.png';
import jogaImg from '../images/joga.png';
import ladyImg from '../images/lady.png';
import legImg from '../images/leg.png';
import targetImg from '../images/target.png';
import { GoalId } from '../types/models/goals';

export const goalImages: Record<GoalId, string> = {
  rest_and_sleep_better: ladyImg,
  feel_better_in_your_body: heartImg,
  make_movement_a_habit: legImg,
  feel_calmer_under_stress: jogaImg,
  find_your_focus: targetImg,
  nail_your_nutrition: foodImg,
  build_better_money_habits: handImg,
};
